<template>
  <v-dialog v-model="dialog.show" max-width="500" persistent>
    <v-card>
      <v-toolbar :color="getAppBarColor" dark>{{ dialog.title }}</v-toolbar>
      <v-card-text>
        <v-form ref="form">
          <v-row align="center">
            <v-col cols="6">
              <v-text-field
                label="Descrição"
                :rules="[rules.required]"
                v-model="consorcio.descricao"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="Coeficiente Cota Reposição"
                :rules="[rules.required, rules.isNumber]"
                v-model="consorcio.coeficienteCotaRepo"
                suffix="%"
              ></v-text-field>
            </v-col>
            <v-col cols="12" v-if="!dialog.edit">
              <SelectVeiculos :multiple="true" @onChanged="consorcio.veiculos = $event" />
            </v-col>
            <v-col cols="12" v-if="!dialog.edit">
              <SelectEmpresa :multiple="true" @onChanged="consorcio.empresas = $event" />
            </v-col>
            <v-col cols="4">
              <v-checkbox label="Ativo" v-model="consorcio.ativo"></v-checkbox>
            </v-col>
            <v-col cols="4">
              <v-checkbox label="Emplacamento" v-model="consorcio.emplacamento"></v-checkbox>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-1"
          small
          dark
          rounded
          depressed
          @click="dialog.edit ? editItem() : save()"
        >Salvar</v-btn>

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="close()"
        >Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from "@/utils/rules";
import Consorcio from "@/services/consorcio";

export default {
  name: "DialogConsorcio",

  components: {
    SelectEmpresa: () => import("@/components/select/SelectEmpresa"),
    SelectVeiculos: () => import("@/components/select/SelectVeiculos")
  },

  data() {
    return {
      consorcio: {
        ativo: true,
        descricao: "",
        coeficienteCotaRepo: 0,
        emplacamento: true,
        empresas: [],
        veiculos: [],
        dataCriacao: new Date()
      },
      dialog: {
        title: "",
        show: false,
        edit: false
      },
      rules,
      serviceConsorcio: new Consorcio()
    };
  },

  methods: {
    async save() {
      try {
        if (this.$refs.form.validate()) {
          this.consorcio.coeficienteCotaRepo = parseFloat(
            this.consorcio.coeficienteCotaRepo
          );
          const response = await this.serviceConsorcio.create(this.consorcio);
          this.$emit("created", response);
          this.close();
        }
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao cadastrar novo Consorcio");
        return Promise.reject(error);
      }
    },

    async editItem() {
      try {
        if (this.$refs.form.validate()) {
          this.consorcio.coeficienteCotaRepo = parseFloat(
            this.consorcio.coeficienteCotaRepo
          );
          const response = await this.serviceConsorcio.update({
            ...this.consorcio
          });
          this.$emit("updated", { ...this.consorcio });
          this.close();
        }
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    close() {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.dialog.show = false;
    },

    show(edit, item) {
      if (edit) {
        this.consorcio = { ...item };
        this.dialog.title = "Editar Consorcio";
        this.dialog.edit = true;
      } else {
        this.dialog.title = "Novo Consorcio";
      }
      this.dialog.show = true;
    }
  }
};
</script>
